import React, { Component } from "react";

import { ChooseType } from "./components/ChooseType";
import { ConfirmRun } from "./components/ConfirmRun";
import { ConfirmDelete } from "./components/ConfirmDelete";
import { CyclesComplete } from "./components/CyclesComplete";

export class Dialogs extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  getDialogClass = (dialog) => {
    let dialogs = {
      CHOOSE_TYPE: "thermocycle-dialog-type",
      CONFIRM_RUN: "thermocycle-dialog-run",
      CONFIRM_DELETE: "thermocycle-dialog-delete",
      CYCLES_COMPLETE: "thermocycle-dialog-complete"
    };
    return dialogs.hasOwnProperty(dialog) ? dialogs[dialog] : null;
  };

  getDialog = (currentDialog) => {
    let dialog = null;

    switch (currentDialog) {
      case "CHOOSE_TYPE":
        dialog = (
          <ChooseType
            id={this.props.id}
            setDialogDisplay={this.props.setDialogDisplay}
            addSequence={this.props.addSequence}
            sequence={this.props.sequence}
            setInnerSection={this.props.setInnerSection}
            setEditConnection={this.props.setEditConnection}
          />
        );
        break;
      case "CONFIRM_RUN":
        dialog = (
          <ConfirmRun
            id={this.props.id}
            setDialogDisplay={this.props.setDialogDisplay}
            setInnerSection={this.props.setInnerSection}
          />
        );
        break;
      case "CONFIRM_DELETE":
        dialog = (
          <ConfirmDelete
            id={this.props.id}
            setDialogDisplay={this.props.setDialogDisplay}
            removeSequence={this.props.removeSequence}
            sequence={this.props.sequence}
            setInnerSection={this.props.setInnerSection}
          />
        );
        break;
      case "CYCLES_COMPLETE":
        dialog = (
          <CyclesComplete
            id={this.props.id}
            setDialogDisplay={this.props.setDialogDisplay}
          />
        );
        break;
      default:
      // code block
    }

    return dialog;
  };

  render() {
    return (
      <div
        className={"thermocycler-dialog"}
        style={{
          display: !this.props.displayDialog ? "none" : null,
          zIndex: 99,
        }}
      >
        <div
          className={
            "dialog-inner " + this.getDialogClass(this.props.currentDialog)
          }
        >
          {this.getDialog(this.props.currentDialog)}
        </div>
      </div>
    );
  }
}
